export const cards = [
  {
    product_name: "Hartbee",
    sizes: ["7", "8", "9", "10", "11"],
    colors: ["red", "black", "green", "blue"],
    stars: 5,
    price: "35",
    unit: "USD",
    isNew: true,
    thubnail: "https://i.ibb.co/Q6TMX0Q/shoe2.png",
    product_card_colors: ["#fa782e", "#c82930"],
    description:
      "Experience the next level of running performance with the SprintPro X Performance Running Shoes. Lace them up, hit the road, and unlock your full potential with every stride. Dominate your training sessions, races, and personal bests with these exceptional shoes designed to take you further, faster, and in style.",
  },
  {
    product_name: "Loafers",
    sizes: ["7", "8", "9", "10", "11"],
    colors: ["#E05D3F", "#873A36", "#431B1C", "black"],
    stars: 4,
    price: "23.234",
    unit: "USD",
    isNew: true,
    thubnail: "https://i.ibb.co/hyndzPV/shoe3.png",
    product_card_colors: ["#5D1D88", "#FFB700"],
    description:
      "Experience the next level of running performance with the SprintPro X Performance Running Shoes. Lace them up, hit the road, and unlock your full potential with every stride. Dominate your training sessions, races, and personal bests with these exceptional shoes designed to take you further, faster, and in style.",
  },
  {
    product_name: "Brogue",
    sizes: ["7", "8", "9", "10", "11"],
    colors: ["#B10205", "#FBD902", "#1621D8", "#68C6C0"],
    stars: 2,
    price: "127",
    unit: "USD",
    isNew: false,
    thubnail: "https://i.ibb.co/1z7dSw8/shoe1.png",
    product_card_colors: ["#F04DA1", "#005EAB"],
    description:
      "Experience the next level of running performance with the SprintPro X Performance Running Shoes. Lace them up, hit the road, and unlock your full potential with every stride. Dominate your training sessions, races, and personal bests with these exceptional shoes designed to take you further, faster, and in style.",
  },
];
